import React, { PureComponent } from "react";
import Page from "./Page";

export default class Profile extends PureComponent {
  render() {
    return <Page toolBarTitle="Profil" pageTitle="Profil" />;
  }
}
